import React, { createContext, useState, useContext } from 'react';
import { getToken } from '../utils/storage';

const AuthContext = createContext();
const APP_HOME_URL = '/app/';

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!getToken());
    const [intendedUrl, setIntendedUrl] = useState(APP_HOME_URL);

    const establishSession = () => {
        setIsAuthenticated(true);
    };

    const login = () => {
        setIsAuthenticated(true);
        const targetUrl = intendedUrl || APP_HOME_URL;
        setIntendedUrl(APP_HOME_URL);
        window.location.href = targetUrl; // Redirect after login
    };

    const logout = () => {
        setIsAuthenticated(false);
        setIntendedUrl(APP_HOME_URL);
    };

    const setIntended = (url) => {
        if (url.includes('signin') || url.includes('vhod')) {
            return
        }
        setIntendedUrl(url)
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, setIntended, establishSession }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
